import { Store, State, StateContext, Action, Selector } from '@ngxs/store';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SetLastOpened } from './dashboard-overview.action';

interface DashboardOverviewStateModel {
    lastOpenedIndex: number | null;
}

@State<DashboardOverviewStateModel>({
    name: 'dashboardOverview',
    defaults: {
        lastOpenedIndex: null
    }
})
@Injectable()
export class DashboardOverviewState {
    private http = inject(HttpClient);
    private store = inject(Store);

    @Selector()
    static getLastOpenedIndex(state: DashboardOverviewStateModel): number | null {
        return state.lastOpenedIndex;
    }

    @Action(SetLastOpened)
    setLastOpened(ctx: StateContext<DashboardOverviewStateModel>, action: SetLastOpened) {
        ctx.patchState({ lastOpenedIndex: action.lastOpenedIndex });
    }
}
